// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5ee72f94","512":"5d74c259","749":"84840457"}[chunkId] + ".chunk.js";
};